import apiClient from './apiClient';

export const streitIntegrationApi = {
  get: async () => {
    const response = await apiClient.get('/streit-integration');
    return response.data;
  },

  save: async (data) => {
    const response = await apiClient.post('/streit-integration', data);
    return response.data;
  },

  delete: async () => {
    const response = await apiClient.delete('/streit-integration');
    return response.data;
  },

  testConnection: async () => {
    const response = await apiClient.post('/streit-integration/test');
    return response.data;
  },

  triggerSync: async () => {
    const response = await apiClient.post('/streit-integration/sync');
    return response.data;
  },

  getStatus: async () => {
    const response = await apiClient.get('/streit-integration/status');
    return response.data;
  },

  getLogs: async (params = {}) => {
    const response = await apiClient.get('/streit-integration/logs', { params });
    return response.data;
  },
};
